import Vue from 'vue'
// pluginy
import './plugins/vuetify'
import { store } from './plugins/vuex'

// glowne okno appki
import App from './App.vue'

// routy
import router from './router'

// service worker dla PWA
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// na tej podstawie dorobić by pobieralo APP dla zalogowanego lub HOME dla niezalogowanego
// const Routes = router.options.routes
// const filtered = Routes.filter(route => route.userType !== 'logged')
// console.log(Routes)
// console.log(filtered)
